import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
/** @public */ export const playStoreProductProps = {
    product_identifier: T.string,
    base_plan_identifier: T.string,
    offer: T.union("type", {
        AUTOMATIC: T.object({
            type: T.literal("AUTOMATIC")
        }),
        SPECIFIED: T.object({
            type: T.literal("SPECIFIED"),
            offer_identifier: T.string
        })
    })
};
export const isPlayStoreProduct = (product)=>{
    if (!product) return false;
    if (product.typeName !== "product") return false;
    return product.type === "PLAY_STORE";
};
export const isPlayStoreProductId = (id)=>{
    if (!id) return false;
    return id.startsWith("product:PLAY_STORE:");
};
export const playStoreIdentifierFromProps = (props)=>{
    const { base_plan_identifier, product_identifier, offer } = props;
    return `${base_plan_identifier}:${product_identifier}:${offer.type === "AUTOMATIC" ? "sw-auto" : offer.offer_identifier}`;
};
export const playStorePropsPartialFromIdentifier = (identifier)=>{
    const parts = identifier.split(":");
    if (parts.length < 3) return undefined;
    const [base_plan_identifier, product_identifier, offer_identifier] = parts;
    const offer = offer_identifier === "sw-auto" ? {
        type: "AUTOMATIC"
    } : {
        type: "SPECIFIED",
        offer_identifier: offer_identifier
    };
    return {
        base_plan_identifier: base_plan_identifier,
        product_identifier: product_identifier,
        offer
    };
};
/** @internal */ export const playStoreProductMigrations = defineMigrations({});
export const SWPlayStoreProductInfo = {
    migrations: playStoreProductMigrations,
    props: playStoreProductProps,
    meta: {}
};
